exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dsh-sensor-table {\n  padding: 25px 18px 20px 18px;\n}\n.dsh-sensor-status.error {\n  color: #f00;\n}\n", ""]);
